import Input from "../../../design/Input";


function AccountPass({setDataToPayment, dataToPayment}) {

    return (
        <div className="account-aufa-continer">
            <div className="account-aufa-pass">
                <p>בנק</p>
                <Input textView={'bank'} pattern={'number'} value={dataToPayment.bank} onChange={(value) => setDataToPayment({...dataToPayment, bank: value})} />

                <p>מס' חשבון</p>
                <Input textView={'account'} pattern={'number'} value={dataToPayment.account} onChange={(value) => setDataToPayment({...dataToPayment, account: value})} />

                <p>סניף</p>
                <Input textView={'branch'} pattern={'number'} value={dataToPayment.branch} onChange={(value) => setDataToPayment({...dataToPayment, branch: value})} />

                <p>מס' אסמכתא</p>
                <Input textView={'reference'} pattern={'number'} value={dataToPayment.reference} onChange={(value) => setDataToPayment({...dataToPayment, reference: value})} />
            </div>
        </div>
    )
}


export default AccountPass;